import { stripAbAiGuideVariant } from './abAiGuideUrls'

/**
 * Return the production canonical URL for a path without a trailing slash.
 */
export function getCurrentCanonicalUrl(currentPath: string): string {
  if (currentPath.endsWith('/')) {
    currentPath = currentPath.slice(0, -1)
  }

  // AB AI guide experiments (#13747, #18613): set the canonical URL
  // to the control page, so search engines do not index the variant pages.
  currentPath = stripAbAiGuideVariant(currentPath)

  // We always use the production URL as production is the only
  // place where canonical URL matters.
  return 'https://www.shortform.com' + currentPath
}
